module.exports = __webpack_public_path__ + "img/profile-icon.7b3ad404.svg";